<template>
    <div class="LiquidationTimeline">
      <LiquidationTimeline/>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import LiquidationTimeline from '@/components/EmployeeLiquidationTimeline.vue'
  
  export default {
    name: 'employee-liquidation-timeline-view',
    components: {
      LiquidationTimeline
    }
  }
  </script>
  